import { gql } from '@apollo/client'

export default gql`
  mutation addToCart($cartInfo: CartInfo!, $ecToken: String) {
    addToCart(cartInfo: $cartInfo, ecToken: $ecToken) {
      cart_id
    }
  }
`
